export const createStripeOptions = (
  clientSecret,
  customerSessionClientSecret = null,
) => {
  const base = { paymentMethodCreation: 'manual' }
  const isCustomerSession = clientSecret?.startsWith('cuss_')
  const isSetupIntent = clientSecret?.startsWith('seti_')
  
  if (customerSessionClientSecret?.startsWith('cuss_'))
    return {
      ...base,
      customerSessionClientSecret,
      mode: 'setup',
      currency: 'usd',
    }
  
  if (isCustomerSession)
    return {
      ...base,
      customerSessionClientSecret: clientSecret,
      mode: 'setup',
      currency: 'usd',
    }
  
  if (isSetupIntent)
    return { ...base, clientSecret, currency: 'usd' }
  
  return { ...base, clientSecret }
}

export const createPaymentElementOptions = ({ account = null } = {}) => {
  const options = {
    layout: 'tabs',
    fields: {
      billingDetails: { name: 'auto', email: 'auto', address: 'auto' },
    },
    terms: { card: 'auto' },
  }

  if (account) {
    options.defaultValues = {
      billingDetails: {
        name: account?.name || '',
        email: account?.email || '',
        address: {
          line1: account?.address || '',
          city: account?.city || '',
          state: account?.state || '',
          postal_code: account?.postalCode || '',
          country: account?.country || 'US',
        },
      },
    }
  }

  return options
}

export default {
  createStripeOptions,
  createPaymentElementOptions,
}
